import { daysAgoIso, startOfToday } from './date.utils';

/**
 * Query params for the "past" half of a past/future schedule split.
 *
 * Past is "started before today" (`startsBefore`), never "ended before today"
 * (`endTime`): the list endpoint treats `endTime` as "fully contained", so an
 * event in progress at local midnight (one that crosses midnight, or any
 * multi-day event) would match neither the past window nor the future one
 * (`startTime >= startOfToday`) and vanish from both platforms' lists.
 */
export const pastEventsWindow = (pastDays: number) => ({
  startTime: daysAgoIso(pastDays),
  startsBefore: startOfToday().toISOString(),
});
